
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $abba5c85806499a7$export$2e2bcd8739ae039);
const $5625d0caec0a5724$export$c2f15f629432a51d = [
    "ctrl",
    "alt",
    "meta",
    "shift"
];
const $5625d0caec0a5724$export$a2af00130072d5c1 = "__0_1_2_3_4_5_6_7_8_9_a_b_c_d_e_f_g_h_i_j_k_l_m_n_o_p_q_r_s_t_u_v_w_x_y_z_ _`_'_\"_~_!_@_#_$_%_^_&_*_(_)_._-_+_=_[_]_{_}_<_>_,_/_?_;_:_\\_|_capslock_numlock_enter_tab_arrowdown_arrowleft_arrowright_arrowup_end_home_pagedown_pageup_backspace_delete_insert_escape_f1_f2_f3_f4_f5_f6_f7_f8_f9_f10_f11_f12_f13_f14_f15_f16_f17_f18_f19_f20_f21_f22_f23".split("_");
$5625d0caec0a5724$export$a2af00130072d5c1[1] = "_";
const $5625d0caec0a5724$export$e45cb6485273080e = {};
for (const [i, c] of $5625d0caec0a5724$export$a2af00130072d5c1.entries())$5625d0caec0a5724$export$e45cb6485273080e[c] = i;
const $5625d0caec0a5724$export$9af93bb9e9126a2 = {
    space: " ",
    plus: "+",
    up: "arrowup",
    down: "arrowdown",
    left: "arrowleft",
    right: "arrowright",
    esc: "escape"
};
const $5625d0caec0a5724$export$ec514b5495dfb13a = 4;
const $5625d0caec0a5724$export$2f4b53374d74dab0 = 9;
const $5625d0caec0a5724$export$fa74f81f6fd55da8 = 8;
const $5625d0caec0a5724$export$440ece60bb656d1c = 4;
const $5625d0caec0a5724$export$e81f1a492ca706db = 2;
const $5625d0caec0a5724$export$e16f40decae6aceb = 1;
const $5625d0caec0a5724$export$8c6d6ddef5b40636 = $5625d0caec0a5724$export$2f4b53374d74dab0 + $5625d0caec0a5724$export$ec514b5495dfb13a;
const $5625d0caec0a5724$export$c621bb932db11c84 = 2 ** $5625d0caec0a5724$export$ec514b5495dfb13a;
const $5625d0caec0a5724$export$df1afef858d2d2a1 = 2 ** $5625d0caec0a5724$export$8c6d6ddef5b40636;
const $5625d0caec0a5724$export$4e5c8f1854de11bd = 2 ** (2 * $5625d0caec0a5724$export$8c6d6ddef5b40636);
const $5625d0caec0a5724$export$5a85c95189ba5484 = 2 ** (3 * $5625d0caec0a5724$export$8c6d6ddef5b40636);


function $ac0a99b348b5f621$export$e0c709538cb8ae18(key) {
    let parts;
    if (key === "+") return [
        "+"
    ];
    if ("+" == key.slice(-1)) {
        parts = key.slice(0, -2).split("+");
        parts.push("+");
    } else parts = key.split("+");
    return parts.map((x)=>(0, $5625d0caec0a5724$export$9af93bb9e9126a2)[x] || x);
}
function $ac0a99b348b5f621$export$a0511d6cbab6225d(key) {
    const parts = new Set(key);
    let code = (0, $5625d0caec0a5724$export$e45cb6485273080e)[key[key.length - 1].toLowerCase()] || 0;
    for (const modifier of (0, $5625d0caec0a5724$export$c2f15f629432a51d))code = 2 * code + (parts.has(modifier) ? 1 : 0);
    return code;
}
function $ac0a99b348b5f621$export$b983cdf2c2084305(encodedKey) {
    const charCode = $ac0a99b348b5f621$export$d95305c1c4c40d1d(encodedKey);
    const modifiersCode = $ac0a99b348b5f621$export$a10907c21fef597b(encodedKey);
    const key = [];
    if (modifiersCode & (0, $5625d0caec0a5724$export$fa74f81f6fd55da8)) key.push("ctrl");
    if (modifiersCode & (0, $5625d0caec0a5724$export$440ece60bb656d1c)) key.push("alt");
    if (modifiersCode & (0, $5625d0caec0a5724$export$e81f1a492ca706db)) key.push("meta");
    if (modifiersCode & (0, $5625d0caec0a5724$export$e16f40decae6aceb)) key.push("shift");
    const c = (0, $5625d0caec0a5724$export$a2af00130072d5c1)[charCode];
    if (c) key.push(c);
    return key;
}
function $ac0a99b348b5f621$export$d95305c1c4c40d1d(encodedKey) {
    return encodedKey >> (0, $5625d0caec0a5724$export$ec514b5495dfb13a);
}
function $ac0a99b348b5f621$export$a10907c21fef597b(encodedKey) {
    return encodedKey % (0, $5625d0caec0a5724$export$c621bb932db11c84);
}
function $ac0a99b348b5f621$export$f7511445e7083e2c(previousKey, newKey) {
    if (previousKey === undefined) return false;
    if ($ac0a99b348b5f621$export$d95305c1c4c40d1d(previousKey) > 0) return false;
    const previousModifiers = $ac0a99b348b5f621$export$a10907c21fef597b(previousKey);
    const newModifiers = $ac0a99b348b5f621$export$a10907c21fef597b(newKey);
    if (previousModifiers === newModifiers && $ac0a99b348b5f621$export$d95305c1c4c40d1d(newKey) === 0) return false;
    return (previousModifiers & $ac0a99b348b5f621$export$a10907c21fef597b(newKey)) === previousModifiers;
}



function $654bd5a290ad2f2e$export$c30017717ce2168e(key, type = "keydown") {
    const parts = (0, $ac0a99b348b5f621$export$e0c709538cb8ae18)(key);
    let eventKey = parts.at(-1);
    if ((0, $5625d0caec0a5724$export$9af93bb9e9126a2)[eventKey] !== undefined) eventKey = (0, $5625d0caec0a5724$export$9af93bb9e9126a2)[eventKey];
    if (eventKey === "ctrl") eventKey = "Control";
    if (eventKey === "alt") eventKey = "Alt";
    if (eventKey === "meta") eventKey = "Meta";
    if (eventKey === "shift") eventKey = "Shift";
    return new KeyboardEvent(type, {
        ctrlKey: parts.includes("ctrl"),
        altKey: parts.includes("alt"),
        metaKey: parts.includes("meta"),
        shiftKey: parts.includes("shift"),
        key: eventKey
    });
}
function $654bd5a290ad2f2e$export$81dbaac8d5335cb6(event) {
    let code = (0, $5625d0caec0a5724$export$e45cb6485273080e)[event.key.toLowerCase()] || 0;
    for (const modifier of (0, $5625d0caec0a5724$export$c2f15f629432a51d))code = 2 * code + (event[`${modifier}Key`] ? 1 : 0);
    return code;
}





function $da4e35015add456e$export$b109b10146e8f9ba(sequence) {
    return sequence.map((0, $ac0a99b348b5f621$export$e0c709538cb8ae18));
}
function $da4e35015add456e$export$4cb205243eb10110(sequence) {
    if (sequence.length > 4) throw `Can't encode sequence of more than 4 keys!`;
    let code = 0;
    for (const key of sequence)code = code * (0, $5625d0caec0a5724$export$df1afef858d2d2a1) + (0, $ac0a99b348b5f621$export$a0511d6cbab6225d)(key);
    return code;
}
function $da4e35015add456e$export$52460a43741a23b4(sequence) {
    const keys = [];
    while(sequence > 0){
        keys.unshift((0, $ac0a99b348b5f621$export$b983cdf2c2084305)(sequence % 8192));
        sequence = sequence >> 13;
    }
    return keys;
}
function $da4e35015add456e$export$6199ce3afbf6d7f6(seq) {
    if (seq < (0, $5625d0caec0a5724$export$df1afef858d2d2a1)) return 1;
    if (seq < (0, $5625d0caec0a5724$export$4e5c8f1854de11bd)) return 2;
    if (seq < (0, $5625d0caec0a5724$export$5a85c95189ba5484)) return 3;
    return 4;
}
function $da4e35015add456e$export$8cb364356ea2d022(keys) {
    const result = [];
    let sequenceCode = 0;
    let multiplier = 0;
    for(let i = keys.length - 1; i >= 0; i--){
        sequenceCode = 2 ** multiplier * keys[i] + sequenceCode;
        multiplier = multiplier + 13;
        result.push(sequenceCode);
    }
    return result;
}


function $ab399dbed72cb49c$export$e6a0daad8304de(data = {}) {
    return {
        history: [],
        historySize: 0,
        bindings: new Map(),
        disabledSequenceCodes: new Set(),
        ...data
    };
}
function $ab399dbed72cb49c$export$2666eec10feb506f(state, sequence, fn) {
    const sequenceCode = (0, $da4e35015add456e$export$4cb205243eb10110)((0, $da4e35015add456e$export$b109b10146e8f9ba)(sequence));
    if (!state.bindings.has(sequenceCode)) state.bindings.set(sequenceCode, new Set());
    state.bindings.get(sequenceCode).add(fn);
    return $ab399dbed72cb49c$export$3b88b12a1b2479e8(state);
}
function $ab399dbed72cb49c$export$164d2c5f74d5827c(state, sequence, fn) {
    const sequenceCode = (0, $da4e35015add456e$export$4cb205243eb10110)((0, $da4e35015add456e$export$b109b10146e8f9ba)(sequence));
    const fns = state.bindings.get(sequenceCode);
    if (fns) {
        fns.delete(fn);
        if (fns.size == 0) state.bindings.delete(sequenceCode);
    }
    return $ab399dbed72cb49c$export$3b88b12a1b2479e8(state);
}
function $ab399dbed72cb49c$export$445cc5a591c8a8a2(state, sequence) {
    const sequenceCode = (0, $da4e35015add456e$export$4cb205243eb10110)((0, $da4e35015add456e$export$b109b10146e8f9ba)(sequence));
    state.disabledSequenceCodes.delete(sequenceCode);
    return state;
}
function $ab399dbed72cb49c$export$21b222afdafd214b(state, sequence) {
    const sequenceCode = (0, $da4e35015add456e$export$4cb205243eb10110)((0, $da4e35015add456e$export$b109b10146e8f9ba)(sequence));
    state.disabledSequenceCodes.add(sequenceCode);
    return state;
}
function $ab399dbed72cb49c$export$1191ff934e9b979c(state, event) {
    const key = (0, $654bd5a290ad2f2e$export$81dbaac8d5335cb6)(event);
    const previousKey = state.history.at(-1);
    if ((0, $ac0a99b348b5f621$export$f7511445e7083e2c)(previousKey, key)) state.history.pop();
    state.history.push(key);
    if (state.history.length > state.historySize) state.history.shift();
    return state;
}
function $ab399dbed72cb49c$export$a84ac9f6f555b44a(state) {
    const callbacks = [];
    for (const sequenceCode of (0, $da4e35015add456e$export$8cb364356ea2d022)(state.history)){
        if (state.disabledSequenceCodes.has(sequenceCode)) continue;
        callbacks.push(...state.bindings.get(sequenceCode) || []);
    }
    return callbacks;
}
function $ab399dbed72cb49c$export$d6e5ca10785815df(state, event) {
    state = $ab399dbed72cb49c$export$1191ff934e9b979c(state, event);
    const fns = $ab399dbed72cb49c$export$a84ac9f6f555b44a(state);
    for (const fn of fns)fn(event);
    return [
        state,
        fns
    ];
}
function $ab399dbed72cb49c$export$3b88b12a1b2479e8(state) {
    state.historySize = 0;
    for (const code of state.bindings.keys())state.historySize = Math.max(state.historySize, (0, $da4e35015add456e$export$6199ce3afbf6d7f6)(code));
    return state;
}


class $29636b17a2aa1087$export$a428cd33b25d5283 {
    add(...args) {
        const keys = args.slice(0, -1);
        const fn = args.at(-1);
        this.state = (0, $ab399dbed72cb49c$export$2666eec10feb506f)(this.state, keys, fn);
        return this;
    }
    remove(...args) {
        const keys = args.slice(0, -1);
        const fn = args.at(-1);
        this.state = (0, $ab399dbed72cb49c$export$164d2c5f74d5827c)(this.state, keys, fn);
        return this;
    }
    enable(...keys) {
        this.state = (0, $ab399dbed72cb49c$export$445cc5a591c8a8a2)(this.state, keys);
        return this;
    }
    disable(...keys) {
        this.state = (0, $ab399dbed72cb49c$export$21b222afdafd214b)(this.state, keys);
        return this;
    }
    handle(event) {
        const [state, fns] = (0, $ab399dbed72cb49c$export$d6e5ca10785815df)(this.state, event);
        this.state = state;
        return fns.length > 0;
    }
    constructor(state){
        this.state = state;
        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.handle = this.handle.bind(this);
    }
}



var $2ae344e2615bfe7e$exports = {};


function $abba5c85806499a7$export$2e2bcd8739ae039() {
    return new (0, $29636b17a2aa1087$export$a428cd33b25d5283)((0, $ab399dbed72cb49c$export$e6a0daad8304de)());
}
$parcel$exportWildcard(module.exports, $2ae344e2615bfe7e$exports);


//# sourceMappingURL=index.js.map
